import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from 'src/app/core';

@UntilDestroy()
@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.less']
})
export class SelectComponent implements OnInit {
  @Input() select: Select;
  selectForm: FormGroup;
  @Output() onSelectedValue: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _fb: FormBuilder) { }

  ngOnInit(): void {
    this._buildForm();
  }

  private _buildForm(): void {
    this.selectForm = this._fb.group({
      selectedValue: this.select.selectedValue ?? this.select.nzOptions[0].value,
    });

    this.selectForm.get('selectedValue').valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((value: any) => {
        this.onSelectedValue.emit(value);
      });
  }

}
